import khEvidence from './kh-evidence.js';

export default [
  ...khEvidence,
];
